/*!
 * Copyright (C) Design:Funedikly. All rights reserved.
 */

import { makeStyles } from '@griffel/react';

import { tokens } from './../../utilities';

/**
 * Styles for the Tags slots
 */
export const useTagsStyles = makeStyles({
  root: {
    padding: `4px 12px`,
    margin: `12px 0`,
    display: 'inline-block',
    fontWeigth: tokens.font_weight_lg,
    lineHeight: '2',
    borderBottom: `1px solid ${'white'}`, // ${tokens.}
  },
});
